import React from 'react';
import { Input as AntInput } from 'antd';
import styled from 'styled-components';
import { IconEyeView, IconEyeHide } from '../Icons';

const AntInputPassword = AntInput.Password;

const InputPassword = styled(AntInputPassword).attrs({
  iconRender: (visible) => <span>{visible ? <IconEyeView /> : <IconEyeHide />}</span>
})`
  .ant-input-suffix .ant-input-password-icon {
    color: var(--greyscale-blackish);
    cursor: pointer;
    width: 20px;
    height: 20px;

    svg {
      path {
        stroke: var(--greyscale-blackish);

        &[fill],
        &.fill-path {
          fill: var(--greyscale-blackish);
          stroke: none;
        }
      }
    }
  }
`;

export default InputPassword;
